import { defineComponent as _defineComponent } from 'vue'
import { InviteLinks, meetingConstants } from '@busy-human/opt-library'
import VCheckbox from '@/components/checkmarkbox.vue'
import { ref, onMounted } from 'vue';
import rateField from "@/components/rate-field.vue";
import PopupVideo from '@/components/popup-video.vue';
import { useUserspace } from '@/store/userspace';

type Props = {
    invite: InviteLinks.Model
}
type Emits = {
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}



export default /*#__PURE__*/_defineComponent({
  __name: 'invite-rate',
  props: {
    invite: null
  },
  emits: ["update:invite", "progress", "previous"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
}





const showVideo = ref(false)

const tmpInviteDefaults = InviteLinks.Defaults();

const amount = ref(meetingConstants.DEFAULT_PRICE);
const minutes = ref(tmpInviteDefaults.minutes);
const hasAgreed = ref(true);
const uid = ref<string>()
const availabilityLen = ref()



onMounted(() => {
    let userData = useUserspace().user
    uid.value = userData.$id
    let start = userData.timesAvailable ? userData.timesAvailable[0].startTime : 9
    let end = userData.timesAvailable ? userData.timesAvailable[0].endTime : 17
    availabilityLen.value = (end - start) * 60
})

const previous = () =>{
    emit('previous')
}

const setRate = () => {
    if(props.invite.payer && !hasAgreed.value) return;
    emit('update:invite', {...props.invite, price: {'currency': '$', 'amount': amount.value}, minutes: minutes.value});
    emit('progress');
}




const __returned__ = { props, emit, showVideo, tmpInviteDefaults, amount, minutes, hasAgreed, uid, availabilityLen, previous, setRate, InviteLinks, meetingConstants, VCheckbox, ref, onMounted, rateField, PopupVideo, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})